'use client'

import { ReactNode, useEffect, useId, useState } from "react"

type CheckboxProps = {
    defaultChecked: boolean,
    toggle: Function,
    label: string | ReactNode,
    className?: string,
    readonly?: boolean
}

export default function Checkbox({
    defaultChecked,
    toggle,
    label,
    className = '',
    readonly = false
}: CheckboxProps) {

    const id = useId()

    const [checked, setChecked] = useState(defaultChecked)

    useEffect(() => {
        setChecked(defaultChecked)
    }, [defaultChecked])

    return (
        <div className={"checkbox-wrapper " + className}>
            <input
                type="checkbox"
                id={id}                
                checked={checked}                
                onChange={(e) => {
                    setChecked(!checked)
                    toggle();                    
                }}
                {...readonly && {
                    disabled: true
                }}                
            />
            <label htmlFor={id}>
                <span />
                {label}
            </label>
        </div>
    )
}